import React from 'react';

export function Divider({ className = '' }: { className?: string }) {
  return (
    <div
      className={className}
      style={{
        backgroundColor: 'rgb(204, 204, 204)',
        height: 1,
        width: '100%',
        marginBottom: 0,
      }}
    />
  );
}
